import React, { useState, useEffect } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { order_actions } from "../../../../redux-store";
import { get_current_status } from "../../../../utils";
import ClipLoader from "react-spinners/ClipLoader";
import { Helmet } from "react-helmet";
import { formatPrice } from "../../../../utils/formatPrice";
import ReactPaginate from "react-paginate";
import useDebounce from "./AdWorkShop/hooks/useDebounce";

const OrdersMer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = useLocation();
  const [page, setPage] = useState(1);
  const { user } = useSelector((state) => state.auth);
  const { orders, totalPages } = useSelector((state) => state.order);
  const loading = useSelector((state) => state.global.loading);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("");

  const debouncedSearch = useDebounce(search, 500);

  const getOrders = (page = 1, search = "", filter = "") => {
    const query = {
      search,
      page,
      limit: 5,
      merchantId: user?.user?._id,
    };

    if (filter) {
      query.metric = filter;
    }

    dispatch(order_actions.fetch_orders(query));
  };

  const handlePageChange = ({ selected }) => {
    setPage(selected + 1);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
    setPage(1);
  };

  useEffect(() => {
    getOrders(page, debouncedSearch, filter);
  }, [page, debouncedSearch, filter]);

  useEffect(() => {
    if (user) {
      if (!pathname.includes(user?.user?.role)) {
        history.replace(`/dashboard/${user?.user?.role}`);
      }
    }
  }, [user, pathname, history]);

  return (
    <>
      <Helmet>
        <title>eksplode! | Orders Merchant</title>
      </Helmet>
      <div className="dashboard">
        <div className="box-account box-info">
          <div className="box-head">
            <h2>My Orders</h2>
          </div>
          <div className="row mt-3">
            <div className="col-lg-12 mx-auto register-page section-b-space">
              <div className="theme-card">
                <form className="theme-form">
                  <div className="form-row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          className="form-control mb-0"
                          type="text"
                          name="name"
                          placeholder="Search orders"
                          value={search}
                          onChange={handleSearch}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <select
                          defaultValue={filter}
                          className="form-control mb-0"
                          onChange={handleFilterChange}
                        >
                          <option value="">Apply Filter</option>
                          <option value="in_progress">In progress</option>
                          <option value="delivered">Delivered</option>
                          <option value="checked_out">Checked out</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {loading ? (
                    <div className="box-account box-info mt-3">
                      <div className="my-5 row justify-content-center">
                        <ClipLoader
                          color={"#000000"}
                          loading={loading}
                          size={60}
                        />
                      </div>
                    </div>
                  ) : orders?.length > 0 ? (
                    orders?.map((order) => {
                      const curr_status = get_current_status(order);
                      return (
                        <div
                          className="box-account box-info mt-3"
                          key={order._id}
                        >
                          <div className="row">
                            <div className="col-lg-12 px-5">
                              <div className="box ">
                                <div className="box-title">
                                  <h3>
                                    <span>
                                      Order ID &mdash;{" "}
                                      <b>{order.order_track_id}</b>
                                    </span>
                                    <br />
                                    <small className="text-muted">
                                      Current Status &mdash;{" "}
                                      {curr_status.status_title}
                                    </small>
                                    <br />
                                    <small className="text-muted">
                                      {new Date(
                                        curr_status.status_date
                                      ).toDateString()}
                                    </small>
                                  </h3>
                                  {order.merchant_amount && (
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {formatPrice(order.merchant_amount)}
                                    </a>
                                  )}
                                </div>
                                <div className="box-content">
                                  {order?.product_details?.map(
                                    (item, index) => (
                                      <h6
                                        className="mb-2 d-flex justify-content-between"
                                        key={index}
                                      >
                                        {item.product_name}
                                        <small className="text-muted">
                                          Product Price &mdash;{" "}
                                          {formatPrice(item.product_price)}
                                          <br />
                                          Quantity &mdash;{" "}
                                          {order.items[index].quantity}{" "}
                                        </small>
                                      </h6>
                                    )
                                  )}
                                  <h6>
                                    <Link to={`/order/${order._id}`}>
                                      View Order
                                    </Link>
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr />
                        </div>
                      );
                    })
                  ) : (
                    <div className="box-account box-info mt-3">
                      <div className="my-5 row justify-content-center">
                        <h3>No orders Available</h3>
                      </div>
                    </div>
                  )}
                  {orders?.length > 0 && (
                    <div className="col-12">
                      <div className="d-flex justify-content-center mt-5">
                        <ReactPaginate
                          previousLabel={"<<"}
                          nextLabel={">>"}
                          breakLabel={"..."}
                          pageCount={totalPages}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageChange}
                          containerClassName={"pagination"}
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          breakClassName={"page-item"}
                          breakLinkClassName={"page-link"}
                          activeClassName={"active"}
                          forcePage={page - 1}
                        />
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrdersMer;
